module.exports = __webpack_public_path__ + "static/img/news25.fa287fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news25.png
// module id = i1VU
// module chunks = 0